<div class="status-list">
  <div *ngIf="loading" class="loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  
  <div *ngIf="!loading && hasError" class="error-state">
    {{ 'request_v2.status_list.load_error' | translate }}
  </div>
  
  <div *ngIf="!loading && !hasError && statuses.length === 0" class="empty-state">
    {{ 'request_v2.status_list.no_statuses' | translate }}
  </div>
  
  <app-status-card 
    *ngFor="let status of statuses" 
    [status]="status" 
    [statusType]="getStatusType(status)"
    (edit)="onEdit($event)" 
    (delete)="onDelete(status)">
  </app-status-card>
</div> 